import { ISocialQuoteCarouselFields } from '@/types/contentful';

import { TestimonialDescriptions } from './TestimonialDescriptions';

export function SocialQuoteCarousel({
  header,
  cardTheme,
  testimonialDescriptions
}: ISocialQuoteCarouselFields) {
  return (
    <div className="block-container relative py-25">
      <div className="w-full !max-w-full pl-4 tablet:pl-6 tablet:text-center">
        <h1 className="typography-display-2 mb-10 pr-4 tablet:pr-6 tablet:text-center">
          {header}
        </h1>
        <TestimonialDescriptions
          testimonialDescriptions={testimonialDescriptions ?? []}
          cardTheme={cardTheme}
        />
      </div>
    </div>
  );
}
